const BoolResult = (props: React.PropsWithChildren) => {
    if (props.children === true) return <>Yes</>;
    if (props.children === false) return <>No</>;
    return <>N/A</>;
};

export default BoolResult